module.exports = __webpack_public_path__ + "static/people-e42af2cbe2b5892b07a020b6cc9151ab.png";